
import {set902device, setdevicenotifytype, updatedevice} from '../../api/device'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'childDevice902',
directives: {
TransferDom
},
data () {
return {
showSuc: false,
showSucText: '',
showErr: false,
showErrText: '设备类型失败',
deviceData: '',
setPhone: {
sosphone: '',
phone1: '',
phone2: ''
},

showDisabled: false,
resultWay: [],

setPhoneShow: false,
setTitle: '',
setPhoneOpen: {
devicephone: '',
sosphone: '',
phone1: '',
phone2: ''
},
index: 0
}
},
created () {

this.deviceData = this.$store.getters.get_child_obj
if (this.deviceData.setting !== null && this.deviceData.setting !== '' && this.deviceData.setting.length > 0) {
for (let i = 0; i < this.deviceData.setting.length; i++) {
if (this.deviceData.setting[i].func === 'sosphone') {
this.setPhone = JSON.parse(this.deviceData.setting[0].other)
}
}
}
let notifytype = this.deviceData.notifytype.split('')
if (this.deviceData.phonedevicerole === 'admin') {
this.showDisabled = false
} else {
this.showDisabled = true
}
this.resultWay = []
if (notifytype[0] === '1') {
this.resultWay.push('1')
}
if (notifytype[1] === '1') {
this.resultWay.push('2')
}
if (notifytype[2] === '1') {
this.resultWay.push('3')
}
console.log(902, this.deviceData.notifytype)
},
methods: {

changeWaySend () {

let way = '000'
let notifytype = this.deviceData.notifytype
for (let i = 0; i < this.resultWay.length; i++) {
if (this.resultWay[i] === '1') {
way = '1' + way.slice(1)
} else if (this.resultWay[i] === '2') {
way = way.slice(0, 1) + '1' + way.slice(2)
} else if (this.resultWay[i] === '3') {
way = way.slice(0, 2) + '1'
}
}
notifytype = way + notifytype.slice(3)
let data = {
phone: this.$store.getters.get_user,
did: this.deviceData.id,
notifytype
}
setdevicenotifytype(data).then(res => {
if (res.code === 200) {
this.deviceData.notifytype = data.notifytype
this.$toast.success('成功')
this.$store.commit('set_child_obj', this.deviceData)

} else {
this.$toast.fail('失败')
let wayArr = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
wayArr.push('1')
}
if (notifytype[1] === '1') {
wayArr.push('2')
}
if (notifytype[2] === '1') {
wayArr.push('3')
}
this.resultWay = wayArr
}
}).catch(() => {
let wayArr = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
wayArr.push('1')
}
if (notifytype[1] === '1') {
wayArr.push('2')
}
if (notifytype[2] === '1') {
wayArr.push('3')
}
this.resultWay = wayArr
this.$toast.fail('失败')
})

},
openSet (index) {
this.index = index
if (index === 0) {
this.setTitle = '设置本机号码'
} else if (index === 1) {
this.setTitle = '设置SOS号码'
} else if (index === 2) {
this.setTitle = '设置按钮一号码'
} else if (index === 3) {
this.setTitle = '设置按钮二号码'
}
this.setPhoneOpen = {
devicephone: this.deviceData.devicephone,
sosphone: this.setPhone.sosphone,
phone1: this.setPhone.phone1,
phone2: this.setPhone.phone2
}
this.setPhoneShow = true
},
getShow () {
if (this.index === 0) {
if (this.setPhoneOpen.devicephone === '') {
return true
} else {
return false
}
} else if (this.index === 1) {
if (this.setPhoneOpen.sosphone === '') {
return true
} else {
return false
}
} else if (this.index === 2) {
if (this.setPhoneOpen.phone1 === '') {
return true
} else {
return false
}
} else if (this.index === 3) {
if (this.setPhoneOpen.phone2 === '') {
return true
} else {
return false
}
} else {
return true
}
},
setPhoneSend () {
if (this.index === 0) {
this.setPhoneSend1()
return
}
let data = {
imei: this.deviceData.deviceid,
phone1: this.setPhoneOpen.phone1,
phone2: this.setPhoneOpen.phone2,
sosphone: this.setPhoneOpen.sosphone
}
set902device(data).then(res => {
if (res.code === 200) {
let index = this.index
if (index === 0) {
this.deviceData.devicephone = this.setPhoneOpen.devicephone
} else if (index === 1) {
this.setPhone.sosphone = this.setPhoneOpen.sosphone
} else if (index === 2) {
this.setPhone.phone1 = this.setPhoneOpen.phone1
} else if (index === 3) {
this.setPhone.phone2 = this.setPhoneOpen.phone2
}
this.showSuc = true
this.showSucText = '成功'
this.setPhoneShow = false
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '失败'
})
},
setPhoneSend1 () {
let data = {
did: parseInt(this.deviceData.id),
name: this.deviceData.name,
devicephone: this.setPhoneOpen.devicephone
}
updatedevice(data).then(res => {
if (res.code === 200) {
this.deviceData.devicephone = data.devicephone
this.$emit('getFatherEvent', data.devicephone)
this.showSuc = true
this.showSucText = '成功'
this.setPhoneShow = false
} else {
this.showErr = true
this.showErrText = res.msg
}
}).catch(() => {
this.showErr = true
this.showErrText = '失败'
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/childDevice902.vue